var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangePencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.337891,
    width: 38.5352,
    height: 38,
    rx: 6,
    fill: "#F05A28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1406 28.3334H14.873L27.2956 16.0834C28.6024 14.7947 28.6024 12.7054 27.2956 11.4167C25.9887 10.128 23.87 10.128 22.5632 11.4167L10.1406 23.6667V28.3334",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3809 12.583L26.1133 17.2497",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePencilIcon);
export default __webpack_public_path__ + "static/media/orange-pencil-icon.d8cfd6598b5a75e7382d70ff8a71d792.svg";
export { ForwardRef as ReactComponent };